import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=011c21d9&"
import script from "./Payment.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Payment.vue?vue&type=script&scoped=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports